import { render, staticRenderFns } from "./ModalUpdatePack.vue?vue&type=template&id=2923c71e&scoped=true"
import script from "./ModalUpdatePack.vue?vue&type=script&lang=js"
export * from "./ModalUpdatePack.vue?vue&type=script&lang=js"
import style0 from "./ModalUpdatePack.vue?vue&type=style&index=0&id=2923c71e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2923c71e",
  null
  
)

export default component.exports